import { _ as w } from "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./es.symbol.description-6025a604.js";
import "./es.object.assign-7e79fd7b.js";
import { c as n } from "./index-8b07dec9.js";
import p, { css as a } from "styled-components";
import "./es.array.filter-4e9c9996.js";
import "./es.array.concat-d1c9b847.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.entries-d2a19275.js";
import "./es.object.to-string-f55666a8.js";
import "./es.string.replace-f4cc3aea.js";
import "./es.array.is-array-7a29277f.js";
import "react";
import "./web.dom-collections.for-each-3020ed11.js";
import { g } from "./getMetrics-953aa4f8.js";
import { hTag as W } from "./hTag.js";
import { jsxs as x, jsx as u } from "react/jsx-runtime";
import "./export-cdcbfb2b.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./object-create-9b6715a2.js";
import "./object-keys-719a5561.js";
import "./html-32ef1b46.js";
import "./object-get-own-property-names-external-2f8b4cc4.js";
import "./array-slice-79f93c56.js";
import "./define-built-in-accessor-26bc7b69.js";
import "./iterate-13ada9e5.js";
import "./array-iteration-759bfbfa.js";
import "./function-apply-4756dee6.js";
import "./create-property-f9780ed1.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./array-method-is-strict-e5a3c878.js";
var N = ["actionButtons", "titleProp", "description", "alignment"], d = /* @__PURE__ */ p.div.withConfig({
  displayName: "featureText__StyledFeatureText",
  componentId: "sc-1p84mud-0"
})(["&.FeatureText{", ";}"], function(t) {
  var e = t.theme, r = e.components.featureText, o = e.componentStyles;
  return a(r.FeatureText, o);
}), _ = /* @__PURE__ */ p.div.withConfig({
  displayName: "featureText__FeatureTextWrapper",
  componentId: "sc-1p84mud-1"
})(["&.FeatureText__wrapper{", ";}"], function(t) {
  var e = t.theme.components.featureText;
  return a(e.FeatureTextWrapper);
}), f = /* @__PURE__ */ p(W).withConfig({
  displayName: "featureText__TitleWrapper",
  componentId: "sc-1p84mud-2"
})(["&.FeatureText__title-wrapper{", ";}"], function(t) {
  var e = t.theme.components.featureText;
  return a(e.TitleWrapper);
}), F = /* @__PURE__ */ p.div.withConfig({
  displayName: "featureText__DescriptionWrapper",
  componentId: "sc-1p84mud-3"
})(["&.FeatureText__description-wrapper{", ";}"], function(t) {
  var e = t.theme.components.featureText;
  return a(e.DescriptionWrapper);
}), h = /* @__PURE__ */ p.div.withConfig({
  displayName: "featureText__ActionButtonWrapper",
  componentId: "sc-1p84mud-4"
})(["&.FeatureText__action-button-wrapper{", ";}"], function(t) {
  var e = t.theme.components.featureText;
  return a(e.ActionButtonWrapper);
}), i = function(e) {
  var r = e.actionButtons, o = e.titleProp, m = o === void 0 ? {
    title: "Title",
    headingLevel: "h1",
    size: "large"
  } : o, s = e.description, c = e.alignment, l = c === void 0 ? "left" : c, T = w(e, N), v = g({
    label: "FeatureText"
  });
  return /* @__PURE__ */ x(d, Object.assign({}, T, v, {
    className: n("FeatureText", T.className),
    children: [/* @__PURE__ */ x(_, {
      className: n("FeatureText__wrapper", "FeatureText__wrapper--" + l, {
        "FeatureText__wrapper--showButtonGroup": !!r
      }),
      children: [/* @__PURE__ */ u(f, {
        as: m.headingLevel,
        className: n("FeatureText__title-wrapper", "FeatureText__title-wrapper--" + (m.size || "large")),
        children: m.title
      }), s && /* @__PURE__ */ u(F, {
        className: "FeatureText__description-wrapper",
        children: s
      })]
    }), r && /* @__PURE__ */ u(h, {
      className: n("FeatureText__action-button-wrapper", "FeatureText__action-button-wrapper--" + l),
      children: r
    })]
  }));
};
i.Container = d;
i.Wrapper = _;
i.TitleWrapper = f;
i.ActionButtonWrapper = h;
i.DescriptionWrapper = F;
export {
  i as FeatureText
};
